import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createListViewColumnActions } from './actions';
import { ListViewColumnActions, ListViewColumnState } from './types';

export const useListViewColumnStore = create<ListViewColumnState & ListViewColumnActions>()(
    immer((set, get, store) => ({
        listViewColumns: [],
        loading: false,
        selectedListViewColumn: null,
        loadingListViewColumn: false,
        error: undefined,
        ...createListViewColumnActions(set, get, store),
    })),
);
